import React from "react";

function Gutschein() {
    return (
        <div class="uk-container uk-padding">
            <h2>Geschenkgutschein</h2>
            <br></br>
            <div class="uk-text-left">
                <p>Ihr wollt euren Lieben eine Freude machen? Wie wäre es mit einem Gutschein für einen kreativen Kurs oder individuelle Handwerkskunst?</p>
                <p>Bei mir könnt ihr Gutscheine* ab 20 € erwerben. Der Gutschein kann für einen Einkauf in meiner Werkstatt oder für einen Kurs eingelöst werden.</p>
                <p>Der individuell gestaltete Gutschein kann bei mir abgeholt oder per Post (zzgl. 2 € Versandkostenpauschale) versendet werden.</p>
                <br></br>
                <p><i>*Der Gutschein ist 12 Monate ab Versanddatum gültig und verfällt, wenn er nicht innerhalb von 12 Monaten eingelöst wird. Übersteigt der Gutscheinbetrag den Kaufwert, bleibt die Differenz als Gutschein bestehen. Eine Auszahlung des restlichen Gutscheinbetrags ist nicht möglich.</i></p>
            </div>
        </div>
    );
}

export default Gutschein;